import React from "react";
import { Helmet } from "react-helmet-async";
import logo from "../assets/center_all_pic/AceLOGO.png";

const BASE_URL = "https://aasthacomputers.vercel.app";

const SEO = ({
  title = "Aastha Computers - Learn | Masters | Grow",
  description = "Aastha Computers is Bikaner's most trusted computer coaching institute offering a wide range of computer courses for all age groups. Learn basic to advanced computer skills from certified professionals in Bikaner.",
  pagePath = "/", // <-- only the path here, e.g. "/about"
  image = logo || "https://www.aasthacomputers.vercel.app/default-og-image.jpg",
  type = "website",
  keywords = [
    "Best Computer Classes in Bikaner",
    "Bikaner",
    "Bikaner services",
    "Bikaner education",
    "Bikaner tourism",
    "Bikaner Rajasthan",
    "local in Bikaner",
    "Bikaner coaching",
    "Best Computer Classes",
    "Aastha Computers",
    "RKCL",
    "RSCIT",
    "Tally",
    "Web Development in Bikaner",
    "Best Tally Classes",
    "Computer coaching",
    "Computer Classes",
  ],
  publishedTime, // Optional: for articles/blogs
  author = "Aastha Computers",
}) => {
  // Ensure pagePath starts with a slash
  const path = pagePath.startsWith("/") ? pagePath : `/${pagePath}`;

  // Construct the full URL combining base URL + page path
  const url = `${BASE_URL}${path}`;

  const metaKeywords = keywords.length ? keywords.join(", ") : null;

  return (
    <Helmet>
      {/* Basic Meta */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph Meta (for Facebook, LinkedIn, etc.) */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Aastha Computers" />
      {publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}

      {/* Twitter Card Meta */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@yourTwitterHandle" />

      {/* Author (for blogs) */}
      <meta name="author" content={author} />
    </Helmet>
  );
};

export default SEO;
